import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="w-full px-6 py-24 bg-white" data-id="element-2">
      <div className="max-w-2xl mx-auto" data-id="element-3">
        <AnimatedSection className="mb-16" data-id="element-4">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal text-center mb-12" data-id="element-5">
            ¿Para quién es?
          </h2>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-6">
            <div data-id="element-7">
              <h3 className="text-lg font-bold text-terracotta mb-6 uppercase tracking-wider text-sm" data-id="element-8">
                Esto es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-9">
                {['Tienes 40+ y sientes que esta etapa te cayó encima con todo', 'Extrañas… pero también sabes que mereces paz', 'Te da vergüenza recaer (o volver a escribir)', "Quieres libertad sin necesidad de convertirte en 'dura' o 'fría'", 'Te urge volver a sentirte tú'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/80" data-id="element-10">
                    <Check className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" data-id="element-11" />
                    <span data-id="element-12">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-13">
              <h3 className="text-lg font-bold text-charcoal/40 mb-6 uppercase tracking-wider text-sm" data-id="element-14">
                No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-15">
                {["Buscas que alguien te diga 'tu ex es el villano'", 'Quieres una solución mágica sin hacer 12 minutos al día', 'Estás en riesgo inmediato (busca ayuda profesional urgente)'].map((item, i) => <li key={i} className="flex items-start gap-3 text-charcoal/60" data-id="element-16">
                    <X className="w-5 h-5 text-charcoal/40 flex-shrink-0 mt-0.5" data-id="element-17" />
                    <span data-id="element-18">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </AnimatedSection>
      </div>
    </section>;
}